import React, { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Catalog from './components/Catalog/Catalog';
import CommonHome from './components/CommonHome/CommonHome';
import ProductCard from './components/ProductCard/ProductCard';
import CartContainer from './components/CartContainer/CartContainer';
import CheckoutContainer from './components/CheckoutContainer/CheckoutContainer';
import FavouriteContainer from './components/FavouriteContainer/FavouriteContainer';
import LoginPage from './components/LoginPage/LoginPage';
import AccountPage from './components/AccountPage/AccountPage';
import InfoPage from './components/InfoPage/InfoPage';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';  // Импортируем BrowserRouter
import { Provider } from 'react-redux'; // Импортируем Provider
import store from './store/store'; // Импортируем наш store

let headerContainer = null;
let catalogContainer = null;
let commonHomeContainer = null;
let productCard = null;
let cartContainer = null;
let favouriteContainer = null;
let loginPage = null;
let accountPage = null;
let checkoutContainer = null;
let infoPage = null;
const App = () => {
  // const [cartA, atc] = useState(0);
  useEffect(() => {
    // Проверяем, есть ли контейнеры в DOM и рендерим компоненты в них
    if (!headerContainer && document.getElementById('header-container') && window.reactHeaderData) {
      headerContainer = document.getElementById('header-container');
      const root = createRoot(document.getElementById('header-container'));
      root.render(
        <BrowserRouter>
          <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
            <Header data={window.reactHeaderData} />
          </Provider>
        </BrowserRouter>);
    }
    if (!catalogContainer && document.getElementById('product-catalog-container') && window.reactProductCatalogData) {
      catalogContainer = document.getElementById('product-catalog-container');
      const root = createRoot(document.getElementById('product-catalog-container'));
      root.render(<BrowserRouter>
        <Provider store={store}>
          <Catalog data={window.reactProductCatalogData} />
        </Provider>
      </BrowserRouter>);
    }
    if (!commonHomeContainer && document.getElementById('common-home-container') && window.reactCommonHome) {
      commonHomeContainer = document.getElementById('common-home-container');
      const root = createRoot(document.getElementById('common-home-container'));
      root.render(<BrowserRouter>
        <CommonHome data={window.reactCommonHome} />
      </BrowserRouter>);
    }
    if (!productCard && document.getElementById('product-card') && window.reactProductCard) {
      productCard = document.getElementById('product-card');
      const root = createRoot(document.getElementById('product-card'));
      const productImages = window.reactProductCard.ImagesPath?.$values;
      if (Array.isArray(productImages)) {
        productImages.sort((a, b) => { if (a.SortOrder < b.SortOrder) { return -1; } if (a.SortOrder > b.SortOrder) { return 1; } return 0; });
      }
      root.render(<BrowserRouter>
        <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
          <ProductCard product={window.reactProductCard} />
        </Provider>
      </BrowserRouter>);
    }
    if (!cartContainer && document.getElementById('cart-container') && window.reactCartContainer) {
      cartContainer = document.getElementById('cart-container');
      const root = createRoot(document.getElementById('cart-container'));
      root.render(<BrowserRouter>
        <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
          <CartContainer data={window.reactCartContainer} />
        </Provider>
      </BrowserRouter>);
    }
    if (!favouriteContainer && document.getElementById('favourite-container') && window.reactFavouriteContainer) {
      favouriteContainer = document.getElementById('favourite-container');
      const root = createRoot(document.getElementById('favourite-container'));
      root.render(<BrowserRouter>
        <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
          <FavouriteContainer data={window.reactFavouriteContainer} />
        </Provider>
      </BrowserRouter>);
    }
    if (!loginPage && document.getElementById('login-page') && window.reactLoginPage) {
      loginPage = document.getElementById('login-page');
      const root = createRoot(document.getElementById('login-page'));
      root.render(<BrowserRouter>
        <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
          <LoginPage data={window.reactLoginPage} />
        </Provider>
      </BrowserRouter>);
    }
    if (!accountPage && document.getElementById('account-page') && window.reactAccountPage) {
      accountPage = document.getElementById('account-page');
      const root = createRoot(document.getElementById('account-page'));
      root.render(<BrowserRouter>
        <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
          <AccountPage data={window.reactAccountPage} />
        </Provider>
      </BrowserRouter>);
    }
    if (!checkoutContainer && document.getElementById('checkout-container') && window.reactCheckoutContainer) {
      checkoutContainer = document.getElementById('checkout-container');
      const root = createRoot(document.getElementById('checkout-container'));
      root.render(<BrowserRouter>
        <Provider store={store}> {/* Оборачиваем все приложение в Provider с store */}
          <CheckoutContainer data={window.reactCheckoutContainer} />
        </Provider>
      </BrowserRouter>);
    }
    if (!infoPage && document.getElementById('info-page') && window.reactInfoPage) {
      infoPage = document.getElementById('info-page');
      const root = createRoot(infoPage);
      root.render(<BrowserRouter><InfoPage data={window.reactInfoPage} /></BrowserRouter>);
    }
  }, []);

  return null; // Мы рендерим компоненты через ReactDOM.render, поэтому в самом компоненте ничего не рендерим
};


export default App;
